import type { Project } from '../api/projects.js';

// Disciplina de obra (contexto editado → fallback IA; la resuelve el backend).
// Mapeo enum → etiqueta de display (mismo vocabulario que el mockup de dirección).
const DISCIPLINA_LABEL: Record<string, string> = {
  edificacion: 'Edificación',
  civil_pesada: 'Obra pesada',
  industrial: 'Obra industrial',
  urbanizacion: 'Urbanización',
  // Los tres que el desplegable ofrece y antes no tenían etiqueta: quien elegía
  // "Mixta" no veía NADA donde debía decir el tipo de obra.
  hidraulica: 'Hidráulica / hidrosanitaria',
  electromecanica: 'Instalación electromecánica',
  mixta: 'Mixta',
};

export function disciplinaLabel(p: Project): string | null {
  return p.disciplina ? DISCIPLINA_LABEL[p.disciplina] ?? null : null;
}

// Badge de estado del proyecto con el vocabulario del mockup. Devuelve los
// colores como CSS vars del design system (cambian con el tema).
export function estatusBadge(p: Project): { bg: string; fg: string; label: string } {
  if (p.status === 'archived') return { bg: 'var(--bg-overlay)', fg: 'var(--text-tertiary)', label: 'Archivado' };
  if (p.indexStatus === 'failed') return { bg: 'var(--bad-weak)', fg: 'var(--bad)', label: 'Error' };
  if (p.indexStatus === 'chunking' || p.indexStatus === 'embedding') return { bg: 'var(--warn-weak)', fg: 'var(--warn)', label: 'Procesando' };
  if (p.exportedToOpus) return { bg: 'var(--oficial-weak)', fg: 'var(--oficial)', label: 'Exportado a OPUS' };
  const conc = p.quoteConcepts ?? 0;
  const pct = p.quotedPct ?? 0;
  // Proyecto vacío (sin archivos todavía): NO está "Analizado" — no analizó nada.
  // Antes caía en `conc === 0` y mostraba "Analizado" en un proyecto recién creado.
  if ((p.totalFiles ?? 0) === 0) return { bg: 'var(--bg-overlay)', fg: 'var(--text-tertiary)', label: 'Nuevo' };
  if (conc === 0) return { bg: 'var(--accent-weak)', fg: 'var(--accent)', label: 'Analizado' };
  if (pct === 0) return { bg: 'var(--bg-overlay)', fg: 'var(--text-secondary)', label: 'Catálogos por asignar' };
  if (pct >= 100) return { bg: 'var(--ok-weak)', fg: 'var(--ok)', label: 'Presupuestado' };
  return { bg: 'var(--warn-weak)', fg: 'var(--warn)', label: 'Presupuestando' };
}
